import isServer from '@anm/helpers/is/isServer';

const isIOS = () => !isServer() && /iPhone|iPod|iPad/gi.test(window.navigator.userAgent);

export default isIOS;
